import { Box, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { apiService } from "../apiService"
import { useEffect, useState } from "react"
import { Settings } from "@mui/icons-material"
import CustomLink from "./CustomLink"

const CustomFooter = () => {

  const fffBaseUrl = process.env.REACT_APP_FREE_FIBU_BASE_URL ? process.env.REACT_APP_FREE_FIBU_BASE_URL : 'http://localhost:10101/fff'
  const [versions, setVersions] = useState<{
    freeBillServiceVersion: string
    fileServiceVersion: string
    authenticationServiceVersion: string
  }>()

  const getVersions = async() => {
    try {
      var { data: freeBillServiceVersion } = await apiService.VersionsApi.getFreeBillServiceVersion()
      var { data: fileServiceVersion } = await apiService.VersionsApi.getFileServiceVersion() 
      var { data: authenticationServiceVersion } = await apiService.VersionsApi.getAuthenticationServiceVersion()
      setVersions({
        freeBillServiceVersion: freeBillServiceVersion,
        fileServiceVersion: fileServiceVersion,
        authenticationServiceVersion: authenticationServiceVersion,
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getVersions()
  }, [])

  return (
    <Box 
      display={"flex"} 
      position={"fixed"} 
      flexShrink={0} 
      right={0} 
      bottom={0} 
      left={0} 
      zIndex={100} 
      py={1} 
      px={2} 
      justifyContent={"space-between"} 
      color={grey[500]}
      sx={{backgroundColor: '#fff'}} 
    
    >
      <Box>      
        <CustomLink href={`${fffBaseUrl}/status`} text={`© ${new Date().getFullYear()} freeFiBU GmbH`} /> | <CustomLink href={`https://www.freefibu.de/impressum/`} text="Impressum" /> | <CustomLink href={`https://www.freefibu.de/agb/`} text="AGB" /> | <CustomLink href={`https://www.freefibu.de/datenschutz/`} text="Datenschutz" />
      </Box>
      <Box display={"flex"} alignItems={"center"} fontSize={13}>
        <Settings fontSize={"inherit"} />
        <Typography ml={1} fontSize={"inherit"}>{`FB:${versions?.freeBillServiceVersion}, A:${versions?.authenticationServiceVersion}, F:${versions?.fileServiceVersion}`}</Typography>
      </Box>
    </Box>
  )
}

export default CustomFooter